import { useNavigate } from "react-router-dom";
import type { ReactNode } from "react";
import { Chip, ContentCard, Row, Tooltip } from "@narmi/design_system";
import { useLocalization } from "@fluent/react";
import useTextOverflowTooltip from "./useTextOverflowTooltip";
import styles from "./TransferTilesMenu.module.scss";

type PaymentTileProps = {
  redirect: string;
  icon: string;
  header: ReactNode;
  subHeader: ReactNode;
  showInstantBadge: boolean;
};

const PaymentTile = ({
  redirect,
  icon,
  header,
  subHeader,
  showInstantBadge,
}: PaymentTileProps) => {
  const { l10n } = useLocalization();
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(redirect);
  };

  const { isOverflowing, textRef, tooltipMaxWidth } = useTextOverflowTooltip({
    dependency: subHeader,
  });

  return (
    <ContentCard
      kind="button"
      paddingSize="l"
      radiusSize="m"
      onClick={handleClick}
    >
      <Row>
        <Row.Item>
          <div
            className={`nds-icon-button nds-icon-button--themed ${styles.IconWrapper}`}
          >
            <span
              className={`${icon}`}
              aria-hidden="true"
              style={{ fontSize: "20px" }}
            />
          </div>
        </Row.Item>
        {showInstantBadge && (
          <Row.Item shrink>
            <Tooltip text={l10n.getString("transfer-tiles-instant-options")}>
              <Chip
                kind="success"
                isLabelVisible={false}
                label=""
                endIcon="zap"
              />
            </Tooltip>
          </Row.Item>
        )}
      </Row>
      <div style={{ height: "16px" }} />
      <div>
        <div className={`fontSize--18px fontWeight--semibold ${styles.tileTextHeader}`}>{header}</div>
        {isOverflowing ? (
          <Tooltip
            maxWidth={tooltipMaxWidth}
            text={`${subHeader}`}
            side="bottom"
            wrapperDisplay="block"
          >
            <p
              ref={textRef}
              className={`fontSize--16px ${styles.paymentTileSubHeader}`}
            >
              {subHeader}
            </p>
          </Tooltip>
        ) : (
          <p
            ref={textRef}
            className={`fontSize--16px ${styles.paymentTileSubHeader}`}
          >
            {subHeader}
          </p>
        )}
      </div>
    </ContentCard>
  );
};

export default PaymentTile;
